"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AvailabilityFilter = void 0;
var _node = require("@domain-group/fe-allhomes-library/lib/node");
var _range = require("../range");
var _isShortDate = require("../../utils/is-short-date");
var _simpleSearchQueryField = require("../simple-search-query-field");
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var parseAvailability = availability => {
  if (!availability || typeof availability !== 'string') {
    return null;
  }
  var date = availability;
  var isTo = availability.indexOf('-') === 0;
  date = isTo ? date.slice(1) : date;
  if ((0, _isShortDate.isShortDate)(date)) {
    return isTo ? [null, date] : [date, null];
  }
  return null;
};
class AvailabilityFilter extends _simpleSearchQueryField.SimpleSearchQueryField {
  get validListingTypes() {
    return [..._node.RentListingTypeKeys, 'SHARE_RESIDENTIAL'];
  }
  constructor(searchOptions, value) {
    super(searchOptions, value ? new _range.StringRange(value) : null);
    _defineProperty(this, "urlSlug", AvailabilityFilter.urlSlug);
  }
  getUrlParameterValue() {
    var value = this.internalValue;
    if (!value || value.isEmpty()) {
      return null;
    }
    return value.max && !value.min ? "-".concat(value.max) : "".concat(value.min);
  }
  static fromUrlParameters(searchOptions, q) {
    return new AvailabilityFilter(searchOptions, parseAvailability(q[AvailabilityFilter.urlSlug]));
  }
}
exports.AvailabilityFilter = AvailabilityFilter;
_defineProperty(AvailabilityFilter, "urlSlug", 'availability');